<template>
  <page-list
    :list="list"
    :columns="columns"
    show-tag-columns
    :tagColumnManager="tagColumnManager"
    :tagColumnParamsFormatter="tagColumnParamsFormatter"
    show-tag-filter
    show-tag-filter2
    show-tag-filter3
    show-ext-tags
    show-no-value
    :tagFilterKeys="['with_bill_tags', 'without_bill_tags']"
    :tagFilterKeys2="['with_project_tags', 'without_project_tags']"
    :tagFilterKeys3="['with_instance_tags', 'without_instance_tags']"
    :noDataText="noDataText"
    :tagManagerInstance="tagManagerInstance"
    :tagManagerInstance2="tagManagerInstance2"
    :tagManagerInstance3="tagManagerInstance3"
    ignoreWithUserMetaParam
    ignoreWithUserMetaParam2
    ignoreWithUserMetaParam3
    :export-data-options="exportDataOptions"
    :extTagParams="extTagParams"
    :extTagParams2="extTagParams"
    :extTagParams3="extTagParams"
    :extra-export-params="extraExportParams"
    :before-show-menu="beforeShowMenu"
    showTagConfig
    :tagColumnsGenerator="tagColumnsGenerator"
    :tagColumnsExportKeyFormatter="tagColumnsExportKeyFormatter">
    <template v-slot:group-actions-append>
      <date-time
        class="ml-2"
        :getParams.sync="dateParams"
        @refresh="fetchData"
        :defaultDateMode="defaultDate.dateMode"
        :defaultTime="defaultDate.date"
        :disableLocalTime="defaultDate.date.start"
        :disableLocalTimeSet="defaultDate.date.start"
        start="start_day"
        end="end_day"
        showStartMonthTip
        paramTimeFormatter="YYYYMMDD" />
      <a-checkbox class="ml-2 mr-2" :checked="showZeroBills" @change="(e) => setShowZeroBills(e.target.checked)">{{ $t('bill.contain_amount_0') }}</a-checkbox>
    </template>
    <div class="d-flex mt-2" slot="table-prepend">
      <div class="mt-1 mb-1">
        <span>{{$t('bill.text_119')}}</span>
        <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ total_amount | moneyFilter }}</span>
        <template v-if="isSecondaryAmountShow">
          <span>, </span>
          <span class="ml-2">{{$t('bill.secondary_total')}}</span>
          <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ total_secondary_amount | moneyFilter }}</span>
        </template>
        <span>, </span>
        <span class="ml-2">{{$t('bill.gross_total')}}</span>
        <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ total_gross_amount | moneyFilter }}</span>
        <span>, </span>
        <span class="ml-2">{{$t('bill.paid_total')}}</span>
        <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ total_paid_amount | moneyFilter }}</span>
        <span>, </span>
        <span class="ml-2">{{$t('bill.discount_total')}}</span>
        <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ total_discount_amount | moneyFilter }}</span>
      </div>
    </div>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import { mapState, mapMutations } from 'vuex'
import { CHARGE_TYPE, PROJECT_TYPE } from '@Bill/constants'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { numerify } from '@/filters'
import { uuid } from '@/utils/utils'
import { getNameFilter, getBrandDistinctFilter, getAccountFilter, getDistinctFieldFilter, getTimeRangeFilter, getDistinctFieldsFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getBillResourceTypeLabel } from '@Bill/utils'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillDetailList',
  components: {
  },
  filters: {
    moneyFilter (val) {
      return numerify(val, '0,0.00')
    },
  },
  mixins: [WindowsMixin, currencyRequest, ListMixin, ColumnsMixin],
  props: {
    id: String,
    cloudEnv: {
      type: String,
    },
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    const filterOptions = {
      id: getNameFilter({ field: 'id', label: this.$t('bill.text_134') }),
      external_id: getNameFilter({ field: 'external_id', label: this.$t('bill.external_id') }),
      resource_id: getNameFilter({ field: 'resource_id', label: this.$t('bill.text_120') }),
      name: getNameFilter({ field: 'resource_name', label: this.$t('bill.text_72') }),
      resource_name: getNameFilter({ field: 'resource_name', label: this.$t('bill.text_72') }),
      account: getAccountFilter({
        distinctType: 'field',
        formatter: (val, condition) => {
          const accountVal = val.map(key => `'${key}'`)
          return `account.${condition === 'not_equals' ? 'notin' : 'in'}(${accountVal})`
        },
        getParams: { $t: uuid() },
        supportNegation: true,
      }),
      owner_name: {
        label: this.$t('bill.owner_account'),
        filter: true,
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'account',
          getParams: { $t: uuid() },
        },
        formatter: (val, condition) => {
          const realVal = val.map(item => `'${item}'`)
          return `account.${condition === 'not_equals' ? 'notin' : 'in'}(${realVal})`
        },
        supportNegation: true,
      },
      linked_name: {
        label: this.$t('bill.linked_account'),
        filter: true,
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'owner_name',
          getParams: { $t: uuid() },
        },
        formatter: val => {
          const realVal = val.map(item => `'${item}'`)
          return `owner_name.in(${realVal})`
        },
      },
      cloudprovider_id: getDistinctFieldsFilter({
        field: ['cloudprovider_name', 'cloudprovider_id'],
        type: 'field',
        label: this.$t('dictionary.cloudprovider'),
        filter: true,
        mapper: (list, data) => {
          const { fields = [] } = data
          const ret = fields.map(item => ({ label: item.cloudprovider_name, key: item.cloudprovider_id })).filter(item => item.label && item.key)
          const ret2 = ret.map(item => {
            const len = ret.filter(l => l.label === item.label).length
            if (len > 1) {
              item.label = `${item.label} (${(item.key || '').substring(0, 6)})`
            }
            return item
          })
          return ret2
        },
        formatter: (val, condition) => {
          const realVal = val.map(item => `'${item}'`)
          return `cloudprovider_id.${condition === 'not_equals' ? 'notin' : 'in'}(${realVal})`
        },
        getParams: { $t: uuid() },
        supportNegation: true,
      }),
      region: getDistinctFieldFilter({
        label: this.$t('res.region'),
        type: 'field',
        field: 'region',
        multiple: true,
        filter: true,
        formatter: (val, condition) => {
          const list = val.map(key => `"${key}"`)
          return `region.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        getParams: { $t: uuid() },
        supportNegation: true,
      }),
      origin_region: getDistinctFieldFilter({
        label: this.$t('meter.origin_region'),
        type: 'field',
        field: 'origin_region',
        multiple: true,
        filter: true,
        formatter: (val, condition) => {
          const list = val.map(key => `"${key}"`)
          return `origin_region.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        getParams: { $t: uuid() },
        supportNegation: true,
      }),
      brand: getBrandDistinctFilter({ getParams: { $t: uuid() }, supportNegation: true }),
      domain: getDistinctFieldFilter({
        label: this.$t('table.title.domain'),
        type: 'field',
        field: 'domain',
        multiple: true,
        filter: true,
        formatter: val => {
          const list = val.map(key => `"${key}"`)
          return `domain.in(${list.join(',')})`
        },
        getParams: { $t: uuid() },
      }),
      project: getDistinctFieldFilter({
        label: this.$t('dictionary.project'),
        type: 'field',
        field: 'project',
        multiple: true,
        filter: true,
        formatter: val => {
          const list = val.map(key => `"${key}"`)
          return `project.in(${list.join(',')})`
        },
        getParams: { $t: uuid() },
      }),
      charge_type: {
        label: this.$t('bill.text_84'),
        dropdown: true,
        multiple: true,
        items: [
          { label: CHARGE_TYPE.postpaid, key: 'postpaid' },
          { label: CHARGE_TYPE.prepaid, key: 'prepaid' },
          { label: CHARGE_TYPE.amortized, key: 'amortized' },
        ],
      },
      project_type: {
        label: this.$t('bill.title.project_type'),
        dropdown: true,
        multiple: true,
        items: [
          { label: PROJECT_TYPE.syncpolicy, key: 'syncpolicy' },
          { label: PROJECT_TYPE.default, key: 'default' },
          { label: PROJECT_TYPE.sharing, key: 'sharing' },
        ],
        supportNegation: true,
      },
      res_type: {
        label: this.$t('bill.text_73'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'resource_type',
          getParams: { $t: uuid() },
        },
        mapper: data => {
          return data.map(item => {
            return {
              key: item.key,
              label: getBillResourceTypeLabel(item.key),
            }
          })
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const realVal = val.map(item => `'${item}'`)
          return `resource_type.${condition === 'not_equals' ? 'notin' : 'in'}(${realVal})`
        },
        supportNegation: true,
      },
      origin_res_type: {
        label: this.$t('bill.title.origin_res_type'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'origin_res_type',
        },
        filter: true,
        multiple: true,
        // formatter: val => `origin_res_type.equals(${val.map(key => `'${key}'`).join(',')})`,
        formatter: (val, condition) => {
          const realVal = val.map(item => `'${item}'`)
          return `origin_res_type.${condition === 'not_equals' ? 'notin' : 'in'}(${realVal})`
        },
        supportNegation: true,
      },
      ip_addr: {
        label: 'IP',
        filter: true,
        formatter: val => {
          return `ip_addr.contains(${val})`
        },
      },
      external_project_name: {
        label: this.$t('bill.external_project'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'external_project_name',
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const realVal = val.map(item => `'${item}'`)
          return `external_project_name.${condition === 'not_equals' ? 'notin' : 'in'}(${realVal})`
        },
        supportNegation: true,
      },
      financial_unit: {
        label: this.$t('bill.financial_unit'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'financial_unit',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `financial_unit.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      spec: {
        label: this.$t('meter.bill_impact_factor'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'spec',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `spec.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      usage_type: {
        label: this.$t('bill.usage_type'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'usage_type',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `usage_type.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      origin_usage_type: {
        label: this.$t('bill.origin_usage_type'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'origin_usage_type',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `origin_usage_type.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      aggregate_usage_unit: {
        label: this.$t('meter.aggregate_usage_unit'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'aggregate_usage_unit',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `aggregate_usage_unit.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      origin_record_type: {
        label: this.$t('meter.origin_record_type'),
        dropdown: true,
        distinctField: {
          type: 'field',
          key: 'origin_record_type',
          getParams: { $t: uuid() },
        },
        filter: true,
        multiple: true,
        formatter: (val, condition) => {
          const list = val.map(key => `'${key}'`)
          return `origin_record_type.${condition === 'not_equals' ? 'notin' : 'in'}(${list.join(',')})`
        },
        supportNegation: true,
      },
      instance_created_at: getTimeRangeFilter({ label: this.$t('meter.instance_create_time'), field: 'instance_created_at' }),
      instance_deleted_at: getTimeRangeFilter({ label: this.$t('meter.instance_delete_time'), field: 'instance_deleted_at' }),
    }
    const keys = Object.keys(filterOptions)
    keys.map(key => {
      if (this.$isScopedPolicyMenuHidden(`fee_hidden_items.${key}`) || this.$isScopedPolicyMenuHidden(`bill_detail_hidden_columns.${key}`)) {
        delete filterOptions[key]
      }
    })
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'payment_bills',
        apiVersion: 'v1',
        getParams: this.getParams,
        fetchDataCb: this.getTotal,
        noPreLoad: true,
        filterOptions,
        hiddenColumns: ['usage_type', 'rate', 'amount_sec', 'external_name', 'cloudprovider', 'spec'],
      }),
      extraExportParams: {
        time_zone: 'UTC+' + (0 - new Date().getTimezoneOffset() / 60),
      },
      envParams: {},
      dateParams: {},
      total_amount: 0,
      total_secondary_amount: 0,
      total_gross_amount: 0,
      total_paid_amount: 0,
      total_discount_amount: 0,
      noDataText: this.$t('bill.text_85'),
      beforeShowMenu () {
        return this.$store.dispatch('scopedPolicy/get', {
          category: ['bill_detail_hidden_columns'],
        })
      },
    }
  },
  computed: {
    ...mapState('bill', {
      showZeroBills: state => state.showZeroBills,
    }),
    isSecondaryAmountShow () {
      return this.$store.getters.isAdminMode && !this.currencyParams.disable_cost_conversion
    },
    extTagParams () {
      const { start_day, end_day, data_type } = this.getParams()
      return {
        start_day,
        end_day,
        data_type,
        ...this.currencyParams,
      }
    },
    defaultDate () {
      const { start_date, end_date } = this.$route.params
      if (start_date && end_date) { // YYYY-MM-DDTZ
        return { dateMode: 'custom', date: { start: this.$moment(start_date.replace('TZ', '')), end: this.$moment(end_date.replace('TZ', '')) } }
      }
      return { dateMode: 'month', date: {} }
    },
    exportDataOptions () {
      return {
        items: ([
          { key: 'id', label: this.$t('bill.text_134') },
          { key: 'account', label: this.$t('bill.text_60') },
          { key: 'brand', label: this.$t('bill.text_81') },
          { key: 'region', label: this.$t('bill.text_83') },
          { key: 'domain', label: this.$t('dictionary.domain') },
          { key: 'project', label: this.$t('dictionary.project') },
          { key: 'ip_addr', label: 'IP' },
          { key: 'usage', label: this.$t('bill.text_131') },
          { key: 'external_id', label: this.$t('bill.external_id') },
          { key: 'usage_unit', label: this.$t('bill.text_281') },
          { key: 'rate', label: this.$t('meter.unit_price') },
          { key: 'price_unit', label: this.$t('meter.price_unit') },
          { key: 'aggregate_usage', label: this.$t('meter.aggregate_usage') },
          { key: 'aggregate_usage_unit', label: this.$t('meter.aggregate_usage_unit') },
          { key: 'resource_type', label: this.$t('bill.text_73') },
          { key: 'origin_res_type', label: this.$t('bill.title.origin_res_type') },
          { key: 'resource_name', label: this.$t('bill.text_72') },
          { key: 'resource_id', label: this.$t('bill.text_120') },
          { key: 'charge_type', label: this.$t('bill.text_84') },
          { key: 'day', label: this.$t('bill.title.day') },
          { key: 'project_type', label: this.$t('bill.title.project_type') },
          { key: 'usage_type', label: this.$t('bill.usage_type') },
          { key: 'origin_usage_type', label: this.$t('bill.origin_usage_type') },
          { key: 'origin_record_type', label: this.$t('meter.origin_record_type') },
          { key: 'origin_region', label: this.$t('meter.origin_region') },
          { key: 'external_id', label: this.$t('bill.external_id') },
          { key: 'instance_type', label: this.$t('meter.instance_type') },
          { key: 'usage_duration', label: this.$t('meter.usage_duration') },
          { key: 'usage_duration_unit', label: this.$t('meter.usage_duration_unit') },
          { key: 'discount', label: this.$t('meter.discount_rate') },
          { key: 'gross_amount', label: this.$t('bill.bill_type.gross_value') },
          { key: 'paid_amount', label: this.$t('bill.bill_type.paid_value') },
          { key: 'discount_amount', label: this.$t('bill.bill_type.discount_value') },
          { key: 'amount', label: this.$t('bill.text_125') },
          { key: 'amount_sec', label: this.$t('bill.converted_amount') },
          { key: 'spec', label: this.$t('bill.text_150') },
          { key: 'tags', label: this.$t('dictionary.bill_tags') },
          { key: 'instance_created_at', label: this.$t('meter.instance_create_time') },
          { key: 'instance_deleted_at', label: this.$t('meter.instance_delete_time') },
        ]).filter(item => {
          return !this.$isScopedPolicyMenuHidden(`bill_detail_hidden_columns.${item.key}`)
        }),
        supportOfflineExport: true,
        offlineExportDescription: this.$t('bill.daily_bill_detail'),
      }
    },
  },
  watch: {
    cloudEnv (val) {
      switch (val) {
        case 'onpremise':
          this.envParams = { is_on_premise: true }
          break
        case 'private':
          this.envParams = { private_cloud: true }
          break
        case 'public':
          this.envParams = { public_cloud: true }
          break
        default:
          this.envParams = {}
      }
      this.fetchData()
    },
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
    showZeroBills () {
      this.fetchData()
    },
  },
  created () {
    this.tagManagerInstance = new this.$Manager('res_tag_details', 'v1')
    this.tagManagerInstance2 = new this.$Manager('project_tag_details', 'v1')
    this.tagManagerInstance3 = new this.$Manager('instance_tag_details', 'v1')
  },
  mounted () {
    this.initListFilter()
  },
  methods: {
    ...mapMutations('bill', {
      setShowZeroBills: 'UPDATE_ZERO_BILL_SHOW',
    }),
    getParams () {
      const ret = {
        admin: this.$store.getters.isAdminMode,
        // group: ['resource_id'],
        ...this.currencyParams,
        ...this.dateParams,
        ...this.envParams,
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
        // ret.data_type = 'day'
        ret.order_by = 'day'
        ret.order = 'asc'
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (!this.showZeroBills) {
        ret.skip_zero_bills = true
      }
      return ret
    },
    tagColumnManager ({ params }) {
      return this.tagManagerInstance.list({
        params,
      })
    },
    tagColumnParamsFormatter () {
      return {
        limit: 2048,
        offset: 0,
        with_cloud_meta: true,
        key_prefix: ['user:', 'ext:'],
        scope: this.$store.getters.scope,
        key_only: true,
        resources: 'payment_bill',
        ...this.dateParams,
        ...this.extTagParams,
      }
    },
    tagColumnsGenerator (keys) {
      const columns = keys.map((key, index) => {
        return {
          field: key,
          key: `tag:${key}`,
          title: key.replace('user:', '').replace('ext:', ''),
          label: key.replace('user:', '').replace('ext:', ''),
          slots: {
            tag_type: () => {
              return 'resource'
            },
            default: ({ row }) => {
              const value = (row.tags || {})[key] || '-'
              return R.is(Array, value) ? value.join(',') : value
            },
          },
          formatter: ({ row }) => {
            const value = (row.tags || {})[key] || '-'
            return R.is(Array, value) ? value.join(',') : value
          },
        }
      })
      return columns
    },
    tagColumnsExportKeyFormatter (key) {
      return `tags.${key}`
    },
    fetchData () {
      this.list.fetchData()
    },
    initListFilter () {
      const initFilter = {}
      const params = this.$route.params
      const {
        charge_type,
        is_prepaid_amortizing,
        is_project_sharing,
        tag,
        instance_tag,
        project_tag,
      } = params
      if (charge_type) {
        initFilter.charge_type = [charge_type]
      }
      ['brand', 'account', 'cloudprovider_id', 'region', 'origin_region', 'domain', 'project', 'resource_type', 'financial_unit', 'spec', 'owner_name', 'linked_nmae', 'origin_res_type', 'external_project_name', 'usage_type', 'product_type', 'aggregate_usage_unit', 'origin_record_type', 'origin_usage_type'].map(key => {
        if (params[key] && params[key].length) {
          initFilter[key] = params[key]
          if (params[`${key}_condition`] === 'not_equals') {
            initFilter[`__condition_${key}`] = 'not_equals'
          }
        }
      })
      this.list.changeFilter(initFilter)
      if (is_prepaid_amortizing) {
        this.$emit('updateBillShared', true)
      }
      if (is_project_sharing) {
        this.$emit('updateProjectShared', true)
      }
      if (tag && !R.isEmpty(tag)) {
        this.list.changeTagFilter(tag)
      }
      if (project_tag && !R.isEmpty(project_tag)) {
        this.list.changeTagFilter2(project_tag)
      }
      if (instance_tag && !R.isEmpty(instance_tag)) {
        this.list.changeTagFilter3(instance_tag)
      }
    },
    dateChange (date) {
      this.list.getParams = { ...this.list.getParams, ...date }
      this.list.reset()
      this.fetchData()
    },
    async getTotal (response) {
      const { totals = {} } = response.data
      const {
        total_amount = 0,
        total_secondary_amount = 0,
        total_gross_amount = 0,
        total_paid_amount = 0,
      } = totals
      this.total_amount = total_amount
      this.total_secondary_amount = total_secondary_amount
      this.total_gross_amount = total_gross_amount
      this.total_paid_amount = total_paid_amount
      this.total_discount_amount = total_gross_amount - total_amount
    },
  },
}
</script>

<!--<style lang="less" scoped>-->
<!--::v-deep .list-body-cell-wrap {-->
<!--  .slot-wrap {-->
<!--    width: 100%!important;-->
<!--  }-->
<!--}-->
<!--</style>-->
